export const TableData = [""];

export const TableColumns = [
  {
    title: "First Name",
    dataIndex: "first_name",
    key: "first_name",
    ellipsis: true,
  },
  {
    title: "Last Name",
    dataIndex: "last_name",
    key: "last_name",
    ellipsis: true,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    ellipsis: true,
  },
  {
    title: "Investment Amount",
    dataIndex: "investment_amount",
    key: "investment_amount",
    ellipsis: true,
  },
  {
    title: "Investment Status",
    dataIndex: "investment_status",
    key: "investment_status",
    ellipsis: true,
  },
  {
    title: "Docs",
    dataIndex: "docs",
    key: "docs",
    ellipsis: true,
  },
];
